import './melgroupleonda/style';
import FormStructure from './melgroupleonda/form_structure';

export default FormStructure;